import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from './Header';
import './DocumentNotFound.css';

const DocumentNotFound = () => {
  const { t } = useTranslation();
  return (
    <div className="document-not-found">
      <Header />
      <div className="document-not-found__content">
        <h1>{t('notFound.title')}</h1>
        <p>{t('notFound.desc')}</p>
      </div>
    </div>
  );
};

export default DocumentNotFound; 
